<template>
  <div class="personal-loan-interest-rate">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">
          {{ $t('list.createPersonalLoanInterestRate') }}
        </h3>
      </div>
      <div class="box-body">
        <personal-loan-interest-rate-form />
      </div>
    </div>
  </div>
</template>

<script>
import PersonalLoanInterestRateForm from './Form'
export default {
  name: 'Create',
  metaInfo () {
    return {
      title: this.$t('string.newPersonalLoanInterestRate'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  components: { PersonalLoanInterestRateForm }
}
</script>

<style scoped>

</style>
